module.exports = __webpack_public_path__ + "media/sidebar/sb_leasing-96ffe1d4.svg";